export const room = {
  rent_bc_submit_disable_portals: {
    active_portal_site: [],
  },
  rent_bc_regulars: {
    f_tmp_save: 0,
    template_id: null,
    control_no: '',
    real_estate_id: '',
    f_sync_controlno_id: 0,
    room_charge_person1: '',
    room_charge_person2: '',
    room_charge_shop_id: null,
    room_no: '',
    f_suumo_room_no_display: 0,
    f_homes_room_no_display: 0,
    f_athome_room_no_display: 0,
    f_clasmohead_room_no_display: 0,
    f_makesviewh_room_no_display: 0,
    f_churasanya_room_no_display: 0,
    f_reinsokinawa_room_no_display: 0,
    f_hatomarkokinawa_room_no_display: 0,
    f_3nosukeweb_room_no_display: 0,
    f_3nosukeweb2_room_no_display: 0,
    f_3nosukeweb3_room_no_display: 0,
    sel_floor_cat: null,
    floor: '',
    sel_open_direct: null,
    vacancy_div: null,
    f_not_rents: 0,
    move_out_y: null,
    move_out_m: null,
    move_out_d: null,
    previous_move_out_y: null,
    previous_move_out_m: null,
    previous_move_out_d: null,
    recruitment_judgment: null,
    sel_occupancy: null,
    occupancy_y: null,
    occupancy_m: null,
    occupancy_s: null,
    occupancy_d: null,
    reason_consultation: '',
    f_reform: 0,
    renovation_y: null,
    renovation_m: null,
    f_renovation_closs: 0,
    f_renovation_kitchen: 0,
    f_renovation_bath: 0,
    f_renovation_toilet: 0,
    f_renovation_washbowl: 0,
    f_renovation_interior: 0,
    f_renovation_exterior: 0,
    renovation_else: '',
    f_renovation: 0,
    renovation2_y: null,
    renovation2_m: null,
    operation_detail: '',
    apply_agreement: null,
    key_place: '',
    key_no: '',
    sel_key_place: null,
    f_physical_key: 0,
    f_smart_lock: 0,
    f_keypad_lock: 0,
    cancel_announce: null,
    sel_cancel_announce: null,
    introspection_y: null,
    introspection_m: null,
    introspection_d: null,
    f_preview_not_available: 0,
    sel_cleaning_status: null,
    f_owner_attendance: 0,
    f_kanri_attendance: 0,
    f_contact_tel: 0,
    f_contact_fax: 0,
    f_contact_other: 0,
    contact_note: '',
    preview_cautions: '',
    f_campaign: 0,
    ad: null,
    sel_ad: null,
    ad_text: '',
    customer_attach_comment: '',
    rank: null,
    ea_comment: '',
    rent_expense: null,
    f_included_general_expense: 0,
    general_expense: null,
    sel_general: 1,
    sel_general_expense: 3,
    sel_deposit: null,
    deposit_expense: null,
    unit_deposit: null,
    f_general_expense: 0,
    keymoney_expense: null,
    unit_keymoney_expense: null,
    f_pet_keymoney: 0,
    keymoney_expensepet: null,
    unit_pet_keymoney_expense: null,
    f_depositinc_expense_pet: 0,
    f_depositinc_expense_smoking: 0,
    f_depositinc_expense_children: 0,
    depositinc_expense: null,
    unit_depositinc_expense: null,
    sel_repayment_expense: null,
    repayment_expense: null,
    unit_repayment_expense: null,
    repayment_period: null,
    repayment_condition: '',
    key_change_expense: null,
    tax_key_change: null,
    house_cleaning_expense: null,
    tax_house_cleaning: null,
    period_house_cleaning: null,
    heating_maintenance_expense: null,
    tax_heating_maintenance: null,
    period_heating_maintenance: null,
    contract_renewal_fee: null,
    tax_contract_renewal: null,
    period_contract_renewal: null,
    certificate_issuance_fee: null,
    tax_certificate_issuance: null,
    period_certificate_issuance: null,
    pet_deodorant_expense: null,
    tax_pet_deodorant: null,
    period_pet_deodorant: null,
    sel_water_bill: null,
    water_supply_expense: null,
    tax_water_supply: null,
    period_water_supply: null,
    water_bill_remarks: '',
    neighborhood_association_expense: null,
    tax_neighborhood_association: null,
    period_neighborhood_association: null,
    town_fee_remarks: '',
    settlement_service_fee: null,
    tax_settlement_service: null,
    period_settlement_service: null,
    kerosenestove_cleaning_expense: null,
    tax_kerosenestove_cleaning: null,
    period_kerosenestove_cleaning: null,
    airconditioner_cleaning_expense: null,
    tax_airconditioner_cleaning: null,
    period_airconditioner_cleaning: null,
    '24hour_administration_fee': null,
    tax_24hour_administration: null,
    period_24hour_administration: null,
    maintenance_costs: null,
    tax_maintenance_costs: null,
    period_maintenance_costs: null,
    miscellaneous_expense: null,
    tax_miscellaneous_expense: null,
    period_miscellaneous_expense: null,
    trunk_room_fee: null,
    tax_trunk_room: null,
    period_trunk_room: null,
    else_price1_expense: null,
    tax_else_price1: null,
    else_price1_name: '',
    else_price1_period: null,
    else_price2_expense: null,
    tax_else_price2: null,
    else_price2_name: '',
    else_price2_period: null,
    else_price3_expense: null,
    tax_else_price3: null,
    else_price3_name: '',
    else_price3_period: null,
    else_price4_expense: null,
    tax_else_price4: null,
    else_price4_name: '',
    else_price4_period: null,
    else_price5_expense: null,
    tax_else_price5: null,
    else_price5_name: '',
    else_price5_period: null,
    else_price6_expense: null,
    tax_else_price6: null,
    else_price6_name: '',
    else_price6_period: null,
    else_price7_expense: null,
    tax_else_price7: null,
    else_price7_name: '',
    else_price7_period: null,
    else_price8_expense: null,
    tax_else_price8: null,
    else_price8_name: '',
    else_price8_period: null,
    brokerage_fee: null,
    unit_brokerage_fee: null,
    f_brokerage_fee: 0,
    tax_brokerage_fee: null,
    credit_card_payment: null,
    sel_contract: null,
    contract_period: null,
    contract_period_y: null,
    contract_period_m: null,
    contract_term_y: null,
    contract_term_m: null,
    contract_term_d: null,
    sel_contract_period: null,
    f_renewal: 0,
    renewal_fee: null,
    unit_renewal_fee: null,
    renewal_commission_expense: null,
    unit_renewal_commission: null,
    tax_renewal_commission: null,
    renewal_commission_business_expense: null,
    unit_renewal_commission_business_expense: null,
    freerent: null,
    sel_freerent_class: null,
    freerent_note: '',
    rent_terms: '',
    parking_no_free_flag: 0,
    parking_expense: null,
    tax_parking_expense: null,
    parking_deposit_expense: null,
    parking_deposit_expense_type: null,
    parking_keymoney_expense: null,
    parking_keymoney_expense_type: null,
    sel_parking_contract_type: null,
    parking2_no_free_flag: 1,
    parking2_expense: null,
    tax_parking2_expense: null,
    parking2_deposit_expense: null,
    parking2_deposit_expense_type: null,
    parking2_keymoney_expense: null,
    parking2_keymoney_expense_type: null,
    sel_parking2_contract_type: null,
    parking3_no_free_flag: 1,
    parking3_expense: null,
    tax_parking3_expense: null,
    parking3_deposit_expense: null,
    parking3_deposit_expense_type: null,
    parking3_keymoney_expense: null,
    parking3_keymoney_expense_type: null,
    sel_parking3_contract_type: null,
    parking_note: '',
    f_4cars_available: 0,
    f_parking5_or_more: 0,
    f_2parking_parallel: 0,
    f_3parking_parallel: 0,
    f_build_garage: 0,
    f_large_garage: 0,
    f_underground_garage: 0,
    f_shutter_garage: 0,
    f_electric_shutter_garage: 0,
    f_carport: 0,
    f_flat_parking: 0,
    f_self_propelled: 0,
    f_visitor_parking: 0,
    sel_guarantor: null,
    f_waranty_company: 0,
    join_type: null,
    waranty_company: null,
    waranty_fee1: null,
    sel_waranty_fee1_unit: null,
    tax_waranty_fee1: null,
    waranty_fee2: null,
    sel_waranty_fee2_unit: null,
    tax_waranty_fee2: null,
    waranty_fee3: null,
    sel_waranty_fee3_unit: null,
    tax_waranty_fee3: null,
    waranty_fee: '',
    f_insurance: 1,
    insurance_year: null,
    insurance_expense: null,
    tax_insurance: 3,
    insurance_name: '',
    transaction_form: null,
    r_ea_id: null,
    r_ea_charge_id: null,
    sel_futures_confirmation: null,
    confirm_y: null,
    confirm_m: null,
    confirm_d: null,
    r_kashi_local_ksk_id: null,
    r_shoyu_local_ksk_id: null,
    r_kanri_local_ksk_id: null,
    customer_attache_no: 0,
    f_btob_publish: 0,
    homes_customer_classification: null,
    reward_type: null,
    reward_price: null,
    unit_reward: null,
    reward_text: '',
    es_percent: null,
    kyaku_percent: null,
    kashi_percent: null,
    kari_percent: null,
    ad_reprinting: null,
    f_ad_consulting: 0,
    f_homes_between_traders: 0,
    f_suumo_between_traders: 0,
    house_plan: null,
    house_plan_type: null,
    house_plan_detail1_type: null,
    house_plan_detail1_no: null,
    house_plan_detail2_type: null,
    house_plan_detail2_no: null,
    house_plan_detail3_type: null,
    house_plan_detail3_no: null,
    house_plan_detail4_type: null,
    house_plan_detail4_no: null,
    house_plan_detail5_type: null,
    house_plan_detail5_no: null,
    house_plan_detail6_type: null,
    house_plan_detail6_no: null,
    house_plan_detail7_type: null,
    house_plan_detail7_no: null,
    house_plan_detail8_type: null,
    house_plan_detail8_no: null,
    house_plan_detail9_type: null,
    house_plan_detail9_no: null,
    house_plan_detail10_type: null,
    house_plan_detail10_no: null,
    house_plan_detail11_type: null,
    house_plan_detail11_no: null,
    house_plan_detail12_type: null,
    house_plan_detail12_no: null,
    house_plan_detail13_type: null,
    house_plan_detail13_no: null,
    house_plan_detail14_type: null,
    house_plan_detail14_no: null,
    exclusive_area: null,
    youtube_url1: '',
    youtube_url2: '',
    youtube_url3: '',
  },
  rent_bc_equipments: {
    f_children: 0,
    f_instrument: 0,
    f_business: 0,
    f_twopeople: 0,
    f_foreigner: 0,
    f_nightwork: 0,
    f_minor: 0,
    f_diy: 0,
    f_reservation_before_pass: 0,
    f_familytype: 0,
    f_for_couples: 0,
    f_for_newlyweds: 0,
    f_publicassistance: 0,
    f_welfare_service: 0,
    f_condominium: 0,
    f_ur_chintai: 0,
    f_management_association: 0,
    f_superior: 0,
    f_seniors_only_service: 0,
    f_major_it_support: 0,
    f_restore_small_burden: 0,
    f_lgbt_friendly: 0,
    f_monthly: 0,
    f_international_st: 0,
    f_online_naiken: 0,
    f_online_soudan: 0,
    f_no_student_deposit: 0,
    f_no_student_deposit_keymoney: 0,
    sel_initial_cost: null,
    f_subsidized_rental: null,
    tenure_burden_lower: '',
    tenure_burden_upper: '',
    sel_rate_change_category: null,
    rate_of_up: null,
    rent_support_period: null,
    subsidized_rental_remarks: '',
    sel_school_define: null,
    sel_shikikin_student: null,
    sel_single_define: null,
    sel_older_define: null,
    sel_biz_define: null,
    sel_pet_define: null,
    f_cat: 0,
    f_dog: 0,
    sel_roomshare_define: null,
    sel_sex_define: null,
    sel_interphone_type: null,
    f_front_door_chime: 0,
    f_autolock: 0,
    f_double_auto_lock: 0,
    f_monitor_autolock: 0,
    f_dimple: 0,
    f_doublelock: 0,
    f_cardkey: 0,
    f_digital_key: 0,
    f_doortouchkey: 0,
    f_electrickey: 0,
    f_entrancekey: 0,
    f_electriclock: 0,
    f_contactless_ickey: 0,
    f_fingerprintauth: 0,
    f_veinauth: 0,
    f_crime_prevention_thumbturn: 0,
    f_humansensor: 0,
    f_securityshutter: 0,
    f_securityglass: 0,
    f_peepproof_doorscope: 0,
    f_firealarm: 0,
    f_our_manage: 0,
    f_viewopen: 0,
    f_oceanview: 0,
    f_cherryblossoms: 0,
    f_fireworks: 0,
    f_tokyotower: 0,
    f_skytree: 0,
    f_mountfuji: 0,
    f_yokohamalandmarktower: 0,
    f_yokohamamarinetower: 0,
    f_kobeporttower: 0,
    f_tsutenkaku: 0,
    f_kyototower: 0,
    f_higashiyamaskytower: 0,
    f_fukuokatower: 0,
    f_ocean_view: 0,
    twowaylighting_way1: null,
    twowaylighting_way2: null,
    f_sunny: 0,
    f_lightcourt: 0,
    f_twowaylighting: 0,
    f_threewaylighting: 0,
    f_alltwowaylighting: 0,
    f_south_living: 0,
    f_windopen: 0,
    f_threecorner: 0,
    f_fourcorner: 0,
    f_southwest_corner: 0,
    f_fronttub: 0,
    f_cornerroom: 0,
    f_top_floor: 0,
    f_high_floor: 0,
    f_floor2ldk: 0,
    f_floor2living: 0,
    f_ceiling_high: 0,
    f_ceiling_above25: 0,
    f_ceiling_above3: 0,
    f_system_ceiling: 0,
    f_sloped_ceiling: 0,
    f_designers: 0,
    f_interiorconcrete: 0,
    f_movable_partition: 0,
    f_mainstay: 0,
    f_four_pillars: 0,
    f_spandrel_wall: 0,
    f_hotspring: 0,
    f_separated: 0,
    f_with_office: 0,
    f_with_store: 0,
    f_with_dog: 0,
    f_with_cat: 0,
    f_green_curtain: 0,
    f_with_meal: 0,
    f_care_support: 0,
    sel_southdirect_count: null,
    sel_all_direction: null,
    f_lighting: 0,
    f_indirectlighting: 0,
    f_allroomlighting: 0,
    f_autolight: 0,
    f_lighting_human_sensor: 0,
    f_led_light: 0,
    f_adjustable_led_light: 0,
    f_downlight: 0,
    f_foot_light: 0,
    f_step_blackout_light: 0,
    f_flooring: 0,
    f_allflooring: 0,
    f_flooring_replacement: 0,
    f_paddedfloor: 0,
    f_carpet: 0,
    f_florcolorwhite: 0,
    f_impedimentremoval: 0,
    f_flat_floor: 0,
    f_skip_floor: 0,
    f_tatami_corner: 0,
    f_ryukyu_tatami: 0,
    f_solid_wood: 0,
    f_wood_tile: 0,
    f_p_tile: 0,
    f_flooring_tile: 0,
    maisonette_from: '',
    maisonette_to: '',
    loft_count: null,
    f_maisonette: 0,
    f_loft: 0,
    f_symmetry: 0,
    f_wellhole: 0,
    f_living_blowout: 0,
    f_sunroom: 0,
    f_baywindow: 0,
    f_skylight: 0,
    f_doubleglass: 0,
    f_high_sash: 0,
    f_soundproof_sash: 0,
    f_double_sash: 0,
    f_seismic_door: 0,
    f_parent_child_door: 0,
    f_alcove: 0,
    f_frontporch: 0,
    f_entrancehall: 0,
    f_entrancerail: 0,
    f_living_stairs: 0,
    f_inner_stairs: 0,
    f_indoor_spiralstaircase: 0,
    f_stairs_elevator: 0,
    f_stair_handrail: 0,
    f_home_elevator: 0,
    f_multimedia_consent: 0,
    f_all_multimedia_consent: 0,
    f_consent_40more: 0,
    f_wide_switch: 0,
    f_total_heat_exchanger: 0,
    f_picture_window: 0,
    f_natural_materials: 0,
    f_active_carbon: 0,
    f_2doors_1room: 0,
    f_basement: 0,
    f_soundproofchamber: 0,
    f_wasitu_next_living: 0,
    f_wasitu_succession: 0,
    f_study: 0,
    f_tokonoma: 0,
    f_chashitsu: 0,
    f_housework_room: 0,
    f_doma: 0,
    f_freespace: 0,
    f_bedroom_8mat_more: 0,
    f_bedroom_10mat_more: 0,
    f_curtain: 0,
    f_blind: 0,
    f_roolscreen: 0,
    f_bed: 0,
    f_storingbed: 0,
    f_wall_bed: 0,
    f_furniture: 0,
    f_furnitureelectronics: 0,
    f_large_wooden_fixtures: 0,
    f_indoorclothes: 0,
    f_indoor_dryer: 0,
    f_gas_clothes_dryer: 0,
    f_with_phone: 0,
    f_tv: 0,
    f_clothing_dryer: 0,
    f_dining_table: 0,
    veranda_count: null,
    f_veranda: 0,
    f_roofbalcony: 0,
    f_twowaybalcony: 0,
    f_twosidebalcony: 0,
    f_threesidebalcony: 0,
    f_ltypebalcony: 0,
    f_innerbalcony: 0,
    f_south_balcony: 0,
    f_double_balcony: 0,
    f_service_balcony: 0,
    f_balcony_faucet: 0,
    f_wide_balcony: 0,
    f_terrace: 0,
    f_open_terrace: 0,
    f_wooddeck: 0,
    f_privategarden: 0,
    f_middlegarden: 0,
    f_innergarden: 0,
    f_south_garden: 0,
    f_edge_side: 0,
    f_rooftop_garden: 0,
    f_outerpowersupply: 0,
    f_gardening_function: 0,
    f_kitchen_garden: 0,
    f_flower_bed: 0,
    f_flower_box: 0,
    sel_slidingshutter: null,
    f_closet: 0,
    sel_closet_count: null,
    f_walkincloset: 0,
    sel_walkincloset_count: null,
    storeroom_count: null,
    f_shosewalkincloset: 0,
    f_shoescupboard: 0,
    f_ceilingheightshoescupboard: 0,
    f_storingspace: 0,
    f_walkthroughcloset: 0,
    f_japanesecloset: 0,
    f_allfloorstorage: 0,
    f_penty_closet: 0,
    f_understoring: 0,
    f_atticstorageroom: 0,
    f_storagespaceunderstairway: 0,
    f_entrancestrage: 0,
    f_updownwallstoring: 0,
    f_above_closet: 0,
    f_barn: 0,
    f_trunkroom: 0,
    f_warhouse: 0,
    f_linen_storehouse: 0,
    f_storeroom: 0,
    f_storage_1_harf: 0,
    f_storage_2: 0,
    f_storage_2_harf: 0,
    sel_bathtoilet_type: null,
    f_bath: 0,
    f_shower: 0,
    f_additionalbatch: 0,
    f_autobath: 0,
    f_dehumidifierbathroom: 0,
    f_bath_window: 0,
    f_balance_pot: 0,
    f_shower_room: 0,
    f_ontvpath: 0,
    f_audiobath: 0,
    f_sauna: 0,
    f_jetbath: 0,
    f_mistsauna: 0,
    f_twobath: 0,
    f_bathonetsubo: 0,
    f_bath_floor_heating: 0,
    f_joshitsu_ventilationfan: 0,
    f_hinoki_bath: 0,
    f_carari_floor: 0,
    f_flagstone_floor: 0,
    f_saving_shower: 0,
    f_onepush_drainage_tap: 0,
    f_bathtub_handrail: 0,
    f_low_floor_bathtub: 0,
    f_high_insulation_tub: 0,
    f_flangeless_outlet: 0,
    f_bath_wide_mirror: 0,
    f_bath_full_glass: 0,
    f_hot_water_type: 0,
    f_1by2_bathroom_more: 0,
    f_washlet: 0,
    f_warmlet: 0,
    f_tunklesstoilet: 0,
    f_twotoilet: 0,
    f_threetoilet: 0,
    f_borderless_toilet: 0,
    f_bath_windows: 0,
    f_handrails_toilet: 0,
    f_saving_toilet: 0,
    f_genderseparate_toilet: 0,
    f_toilet_washingcounter: 0,
    f_sanitary: 0,
    f_washstand: 0,
    f_bathroom: 0,
    f_independent_washstand: 0,
    f_independentwashroom: 0,
    f_shampoodresser: 0,
    f_threesidedmirrorwashstands: 0,
    f_washroomdoor: 0,
    f_washroomwindow: 0,
    f_slopsink: 0,
    f_washstandtwobowl: 0,
    f_2f_washroom: 0,
    f_toilet_line: 0,
    f_toilet_kneespace: 0,
    f_3mirror_bathroom_vanity: 0,
    f_vertical_light_vanity: 0,
    f_flangeless_flush: 0,
    f_healthmeter_station: 0,
    f_mixing_faucet: 0,
    f_floatline_faucet: 0,
    f_washroom_2way: 0,
    f_washroom_3way: 0,
    f_dressingroom: 0,
    f_hotwatersupplysystem: 0,
    f_gas_hotwater: 0,
    f_threehotwatersupplysystem: 0,
    f_freezing_prevention: 0,
    f_washingmachine: 0,
    sel_washingmachine_place: 0,
    f_systemkitchen: 0,
    f_counterkitchen: 0,
    f_peninsula_kitchen: 0,
    f_openkitchen: 0,
    f_ltypekitchen: 0,
    f_islandkitchen: 0,
    f_kitchen_type_u: 0,
    f_kitchen_type_ii: 0,
    f_kitchen_type_overseas: 0,
    f_independentkitchen: 0,
    f_mini_kitchen: 0,
    f_marble_kitchen: 0,
    f_granite_kitchen: 0,
    f_twokitchen: 0,
    f_kitchen_co: 0,
    f_kitchen_type_2way: 0,
    f_kitchen_type_3way: 0,
    f_kitchen_type_open: 0,
    sel_stove_count: 0,
    sel_stove_type: 0,
    f_stoveok: 0,
    f_stovesetting: 0,
    f_grill: 0,
    f_dishwashingdryer: 0,
    f_slidetype_washerdryer: 0,
    f_tableware_dryer: 0,
    f_gasmicrowaveoven: 0,
    f_gasoven: 0,
    f_gas_range: 0,
    f_glasstopstove: 0,
    f_microwaveoven: 0,
    f_refrigerator: 0,
    f_foodstorage: 0,
    f_dishrack: 0,
    f_allslide_storage: 0,
    f_spice_rack: 0,
    f_smartpocket: 0,
    f_earthquakeproof_cabinet: 0,
    f_disposer: 0,
    f_silent_sink: 0,
    f_filterless_rangehood: 0,
    f_rectified_rangehood: 0,
    f_kitchenhead_mixer_tap: 0,
    f_water_heater: 0,
    f_electric_water_heater: 0,
    f_emergency_capacitor: 0,
    f_kitchen_footwarm: 0,
    f_kitchen_window: 0,
    f_kitchendoor: 0,
    f_electric_cooker: 0,
    f_kitchen_heating: 0,
    f_waterfilter: 0,
    sel_waterfilter: null,
    f_airconditioner: 0,
    sel_airconditioner_count: null,
    f_onlywarmer: 0,
    sel_onlywarmer: null,
    f_onlycooler: 0,
    f_floorheating: 0,
    f_builtinairconditioner: 0,
    f_footwarmer: 0,
    f_fireplace: 0,
    f_centralheating: 0,
    f_keroseneheating: 0,
    f_keroseneffheating: 0,
    f_kerosenboiler: 0,
    f_gasheating: 0,
    f_gasffheating: 0,
    f_gas_stove: 0,
    f_electricheating: 0,
    f_hotwaterheating: 0,
    f_hotwater_heating: 0,
    f_heatstorage_type: 0,
    f_heatstorage_floorheating: 0,
    f_centralairconditioner: 0,
    f_airconditioner_leftover: 0,
    f_twentyfourventiatlion: 0,
    f_passiveventilation: 0,
    f_underfloorventilation: 0,
    f_ceilingfan: 0,
    f_catv: 0,
    sel_catv_type: null,
    f_bs: 0,
    f_cs: 0,
    f_cabled: 0,
    f_uhf: 0,
    f_2telephone_lines: 0,
    f_opticalfiber: 0,
    f_catvinernet: 0,
    f_lan: 0,
    f_wireless_lan: 0,
    f_isdn: 0,
    f_broadband_compatible: 0,
    f_internet_dedicated_line: 0,
    f_other_internet: 0,
    f_freeinternet: 0,
    f_gasinstantwaterheater: 0,
    f_gasboiler: 0,
    f_keroseneinstantwaterheater: 0,
    f_concentration: 0,
    f_ecojaws: 0,
    f_ecocute: 0,
    f_ecofeel: 0,
    f_hotwater_fact: 0,
    f_hotwater_tes: 0,
    f_hotwaterother: 0,
    f_kerosenechimneystove: 0,
    f_kerosenecentralheating: 0,
    f_electricpanelheating: 0,
    f_electricstove: 0,
    f_gascentralheating: 0,
    f_heating_tes: 0,
    f_heating_fact: 0,
    f_fanconvector: 0,
    sel_bathhotwater_type: null,
    sel_ventilation_type: null,
    ventilation_num: null,
    sel_gaspiping: null,
    gaspiping_num: null,
    sel_kerosenepiping: null,
    kerosenepiping_num: null,
    f_individualkerosenepiping: 0,
    sel_kerosenepipingtank_type: null,
    sel_kerosenetank: null,
    kerosenetank_other: '',
  },
  rent_bc_images: {
    house_plan_cap: '',
    house_plan_image: '',
    sel_priority_image: '',
    interior1_cap: '',
    interior1_path: '',
    sel_interior1: null,
    interior1_ai_selected: false,
    interior2_cap: '',
    interior2_path: '',
    sel_interior2: null,
    interior2_ai_selected: false,
    interior3_cap: '',
    interior3_path: '',
    sel_interior3: null,
    interior3_ai_selected: false,
    interior4_cap: '',
    interior4_path: '',
    sel_interior4: null,
    interior4_ai_selected: false,
    interior5_cap: '',
    interior5_path: '',
    sel_interior5: null,
    interior5_ai_selected: false,
    interior6_cap: '',
    interior6_path: '',
    sel_interior6: null,
    interior7_cap: '',
    interior7_path: '',
    sel_interior7: null,
    interior8_cap: '',
    interior8_path: '',
    sel_interior8: null,
    interior9_cap: '',
    interior9_path: '',
    sel_interior9: null,
    interior10_cap: '',
    interior10_path: '',
    sel_interior10: null,
    interior11_cap: '',
    interior11_path: '',
    sel_interior11: null,
    interior12_cap: '',
    interior12_path: '',
    sel_interior12: null,
    interior13_cap: '',
    interior13_path: '',
    sel_interior13: null,
    interior14_cap: '',
    interior14_path: '',
    sel_interior14: null,
    interior15_cap: '',
    interior15_path: '',
    sel_interior15: null,
    interior16_cap: '',
    interior16_path: '',
    sel_interior16: null,
    interior17_cap: '',
    interior17_path: '',
    sel_interior17: null,
    interior18_cap: '',
    interior18_path: '',
    sel_interior18: null,
    interior19_cap: '',
    interior19_path: '',
    sel_interior19: null,
    interior20_cap: '',
    interior20_path: '',
    sel_interior20: null,
    interior21_cap: '',
    interior21_path: '',
    sel_interior21: null,
    interior22_cap: '',
    interior22_path: '',
    sel_interior22: null,
    interior23_cap: '',
    interior23_path: '',
    sel_interior23: null,
    interior24_cap: '',
    interior24_path: '',
    sel_interior24: null,
    interior25_cap: '',
    interior25_path: '',
    sel_interior25: null,
    interior26_cap: '',
    interior26_path: '',
    sel_interior26: null,
    interior27_cap: '',
    interior27_path: '',
    sel_interior27: null,
    interior28_cap: '',
    interior28_path: '',
    sel_interior28: null,
    interior29_cap: '',
    interior29_path: '',
    sel_interior29: null,
    interior30_cap: '',
    interior30_path: '',
    sel_interior30: null,
    sel_panorama_room1: null,
    panorama_room1_path: '',
    sel_panorama_room1_2: null,
    panorama_room2_path: '',
    sel_panorama_room2_2: null,
    sel_panorama_room3: null,
    sel_panorama_room3_2: null,
    panorama_room3_path: '',
    sel_panorama_room4: null,
    sel_panorama_room4_2: null,
    panorama_room4_path: '',
    sel_panorama_room5: null,
    sel_panorama_room5_2: null,
    panorama_room5_path: '',
    sel_panorama_room6: null,
    sel_panorama_room6_2: null,
    panorama_room6_path: '',
  },
  rent_bc_catchcopies: {
    share: {
      catch_common: '',
      suumo_catch: '',
      suumo_net_catch: '',
      homes_catch: '',
      mynavi_catch: '',
      mynavi_charge_id: null,
      mynavi_staff_comment_title: '',
      mynavi_staff_comment: '',
      atbb_pro_comment: '',
      atbb_infosheet_catch1: '',
      atbb_infosheet_catch2: '',
      atbb_end_catch: '',
      homemate_room_catch: '',
      homemate_memo: '',
      homemate_salespoint: '',
      eheya_net_catch: '',
      eheya_special_mention: '',
      smocca_catch: '',
      chintai_catch: '',
      rengotai: '',
      rengotai_only_ownhp: null,
      rengotai_corner: null,
      reblo_roompr: '',
      reblo_detail_title: '',
      reblo_recommend_headline: '',
      reblo_free_notation: '',
      uchina_web1: '',
      uchina_paper1: '',
      uchina_web2: '',
      uchina_paper2: '',
      goohome: '',
      goohome_note2: '',
      yahoo_biko1: '',
      yahoo_pr: '',
      note_common: '',
      suumo_note: '',
      homes_note: '',
      atbb_note: '',
      atbb_note2: '',
      eheya_note: '',
      reins_note2: '',
      reins_note3: '',
      reins_note4: '',
      realestatejapan_note: '',
      realestatejapan_in_note: '',
      smocca_note: '',
    },
    shop: {
      catch_common: '',
      suumo_catch: '',
      suumo_net_catch: '',
      homes_catch: '',
      mynavi_catch: '',
      mynavi_charge_id: null,
      mynavi_staff_comment_title: '',
      mynavi_staff_comment: '',
      atbb_pro_comment: '',
      atbb_infosheet_catch1: '',
      atbb_infosheet_catch2: '',
      atbb_end_catch: '',
      homemate_room_catch: '',
      homemate_memo: '',
      homemate_salespoint: '',
      eheya_net_catch: '',
      eheya_special_mention: '',
      chintai_catch: '',
      rengotai: '',
      rengotai_only_ownhp: null,
      rengotai_corner: null,
      door_search: '',
      door_pr: '',
      makesviewh_catch: '',
      clasmohead_catch: '',
      reblo_roompr: '',
      reblo_detail_title: '',
      housetown1: '',
      housetown2: '',
      housetown3: '',
      housetown4: '',
      housetown5: '',
      housetown_campaign: '',
      uchina_web1: '',
      uchina_paper1: '',
      uchina_web2: '',
      uchina_paper2: '',
      goohome: '',
      goohome_note2: '',
      yahoo_biko1: '',
      yahoo_pr: '',
      submitCyukaio_sales_comment: '',
      submitCyukaio_sales_comment72: '',
      note_common: '',
      suumo_note: '',
      homes_note: '',
      atbb_note: '',
      atbb_note2: '',
      eheya_note: '',
      chintai_note2: '',
      chintai_note: '',
      rengotai_note: '',
      makesviewh_note: '',
      clasmohead_note: '',
      submitCyukaio_note1: '',
      submitCyukaio_note2: '',
      submitCyukaio_staff_comment: '',
      reins_note: '',
      reins_freespace1: '',
      reins_freespace2: '',
      reins_note2: '',
      reins_note3: '',
      reins_note4: '',
      realestatejapan_note: '',
      realestatejapan_in_note: '',
    },
  },
  rent_bc_3nosuke_webs: {
    share: {
      '3nosuke_web_room1': '',
      '3nosuke_web_room2': '',
      '3nosuke_web_room3': '',
      '3nosuke_web_room4': '',
      '3nosuke_web_room5': '',
    },
    shop: {
      '3nosuke_web_room1': '',
      '3nosuke_web_room2': '',
      '3nosuke_web_room3': '',
      '3nosuke_web_room4': '',
      '3nosuke_web_room5': '',
    },
  },
  rent_bc_memos: {
    free_tag1: '',
    free_tag2: '',
    free_tag3: '',
    free_tag4: '',
    free_tag5: '',
    room_memo1: '',
    room_memo2: '',
    room_memo3: '',
    room_memo4: '',
    room_memo_image1_cap: '',
    room_memo_image1_path: '',
    room_memo_image2_cap: '',
    room_memo_image2_path: '',
    room_memo_image3_cap: '',
    room_memo_image3_path: '',
    room_memo_image4_cap: '',
    room_memo_image4_path: '',
    room_memo_image5_cap: '',
    room_memo_image5_path: '',
    room_memo_image6_cap: '',
    room_memo_image6_path: '',
    room_pdf1_path: '',
    room_pdf2_path: '',
    room_pdf3_path: '',
    room_attachment_path: '',
    reins_pdf_path: '',
  },
  rent_bc_extention_bruno: {
    f_showa_construction: 0,
    f_for_women: 0,
    f_br_brand: 0,
    f_br_tower: 0,
    f_br_pet: 0,
    f_high_class: 0,
    f_new_building: 0,
    f_conversion: 0,
    f_with_benefits: 0,
    f_location_focused: 0,
    f_nature_near: 0,
    f_tasteful_appearance: 0,
    f_popular_schooldistrict: 0,
    f_with_pet: 0,
    f_design_decides: 0,
    f_clean_renovation: 0,
    f_maisonette_with_loft: 0,
    f_retro_feeling: 0,
    f_roof_balcony: 0,
    f_detached_house: 0,
    f_rented_house: 0,
    f_bare_concrete: 0,
    f_can_be_modified: 0,
    f_good_view: 0,
    f_large_oneroom: 0,
    f_music_and_instruments: 0,
    f_security_for_women: 0,
    f_brand_mansion: 0,
    f_location_oriented: 0,
    f_soho_possible: 0,
    f_with_garage: 0,
    f_strange_floorplan: 0,
    f_hideaway: 0,
    f_with_garden: 0,
    f_western_style: 0,
    f_bm_with_benefits: 0,
    f_plus_alpha: 0,
    f_much_green: 0,
    f_river: 0,
    f_naturalist: 0,
    f_negative_ion: 0,
    f_downtown_osaka: 0,
    f_br_designers: 0,
    f_reproduction_housing: 0,
    f_old_folk_house: 0,
    f_a_little_strange: 0,
    f_near_shoppingstreet: 0,
    f_cheap: 0,
    f_wide: 0,
    f_pet_ok: 0,
    f_senmon_renovation: 0,
    f_senmon_diy: 0,
    f_senmon_no_obstacles: 0,
    f_senmon_fulfillment: 0,
    f_senmon_roomshare: 0,
    f_senmon_flatfloor: 0,
    f_senmon_new_waterplace: 0,
    f_senmon_all_reform: 0,
    f_senmon_part_reform: 0,
    f_senmon_big1room: 0,
    f_senmon_bedroom_more6: 0,
    f_senmon_all_western: 0,
    f_senmon_japanese_style: 0,
    f_senmon_concrete: 0,
    f_senmon_kitchen_storage: 0,
    f_senmon_refrigerator: 0,
    f_senmon_cooking_space: 0,
    f_senmon_waterplace_window: 0,
    f_senmon_bath_more1416: 0,
    f_senmon_washroom: 0,
    f_senmon_bath_handrail: 0,
    f_senmon_gaswaterheater: 0,
    f_senmon_electricwaterheater: 0,
    f_senmon_hotwatersupply: 0,
    f_senmon_toilet_handrail: 0,
    f_senmon_western_toilet: 0,
    f_senmon_japanese_toilet: 0,
    f_senmon_closet_closet: 0,
    f_senmon_shoesbox: 0,
    f_senmon_fully_furnished: 0,
    f_senmon_storage_enrichment: 0,
    f_senmon_store_allowed: 0,
    br_remarks: '',
    br_recommend_points: '',
    br_catch_title: '',
    br_catch_comment: '',
  },
  rent_bc_extention_kiwami: {
    f_kiwami_seo_catch: '',
    f_kiwami_blog_title: '',
    f_kiwami_comment: '',
    f_kiwami_keyword: '',
    f_kiwami_tower_publish: 0,
    f_kiwami_tower_over20floor: 0,
    f_kiwami_tower_over30floor: 0,
    f_kiwami_tower_over40floor: 0,
    f_kiwami_tower_topfloor: 0,
    f_kiwami_tower_1r_big: 0,
    f_kiwami_tower_condominium: 0,
    f_kiwami_tower_furniture: 0,
    f_kiwami_tower_luxury_equip: 0,
    f_kiwami_tower_over70m2: 0,
    f_kiwami_tower_over80m2: 0,
    f_kiwami_tower_over90m2: 0,
    f_kiwami_tower_over100m2: 0,
    f_kiwami_tower_premium: 0,
    f_kiwami_tower_counterkitchen: 0,
    f_kiwami_tower_largeliving: 0,
    f_kiwami_tower_petok: 0,
    f_kiwami_tower_soho: 0,
    f_kiwami_tower_ceiling_high: 0,
    f_kiwami_tower_designers: 0,
    f_kiwami_tower_location_good: 0,
    f_kiwami_tower_direct_station: 0,
    f_kiwami_tower_initial_zero: 0,
    f_kiwami_tower_fix_window: 0,
    f_kiwami_tower_river_side: 0,
    f_kiwami_tower_park_side: 0,
    f_kiwami_tower_maisonette: 0,
    f_kiwami_tower_good_view: 0,
    f_kiwami_tower_area_a: 0,
    f_kiwami_tower_area_b: 0,
    f_kiwami_tower_area_c: 0,
    f_kiwami_tower_area_d: 0,
    f_kiwami_tower_area_e: 0,
    f_kiwami_tower_area_f: 0,
    f_kiwami_tower_area_g: 0,
    f_kiwami_tower_area_h: 0,
    f_kiwami_tower_area_i: 0,
    f_kiwami_tower_area_j: 0,
    f_kiwami_tower_push_room: 0,
    f_kiwami_designer_publish: 0,
    f_kiwami_designer_concrete: 0,
    f_kiwami_designer_renovation: 0,
    f_kiwami_designer_hight_resident: 0,
    f_kiwami_designer_stylish: 0,
    f_kiwami_designer_maisonette: 0,
    f_kiwami_designer_white_type: 0,
    f_kiwami_designer_wood_type: 0,
    f_kiwami_designer_mania: 0,
    f_kiwami_designer_towermansion: 0,
    f_kiwami_designer_condominium: 0,
    f_kiwami_designer_location_important: 0,
    f_kiwami_designer_new_const: 0,
    f_kiwami_designer_counter_kitchen: 0,
    f_kiwami_designer_penty_closet: 0,
    f_kiwami_designer_largeliving: 0,
    f_kiwami_designer_openview: 0,
    f_kiwami_designer_bigoneroom: 0,
    f_kiwami_designer_full_glass: 0,
    f_kiwami_designer_roof_balcony: 0,
    f_kiwami_designer_jacuzzi: 0,
    f_kiwami_designer_over100m2: 0,
    f_kiwami_designer_petok: 0,
    f_kiwami_designer_not_walk: 0,
    f_kiwami_designer_furniture_consul: 0,
    f_kiwami_designer_retro: 0,
    f_kiwami_designer_initial_zero: 0,
    f_kiwami_designer_parking: 0,
    f_kiwami_designer_soho: 0,
    f_kiwami_designer_riverside: 0,
    f_kiwami_designer_ceiling_high: 0,
    f_kiwami_designer_area_a: 0,
    f_kiwami_designer_area_b: 0,
    f_kiwami_designer_area_c: 0,
    f_kiwami_designer_area_d: 0,
    f_kiwami_designer_area_e: 0,
    f_kiwami_designer_area_f: 0,
    f_kiwami_designer_area_g: 0,
    f_kiwami_designer_area_h: 0,
    f_kiwami_designer_area_i: 0,
    f_kiwami_designer_area_j: 0,
    f_kiwami_designer_push_room: 0,
  },
  rent_bc_panorama_flags: {
    f_suumo_panorama_send: 0,
    f_homes_panorama_send: 0,
  },
  rent_bc_options: {
    theta_360_key: '',
  },
  rent_bc_option_images: {
    image_cap_1: '',
    image_path_1: '',
    image_category_1: null,
    image_cap_2: '',
    image_path_2: '',
    image_category_2: null,
    image_cap_3: '',
    image_path_3: '',
    image_category_3: null,
    image_cap_4: '',
    image_path_4: '',
    image_category_4: null,
    image_cap_5: '',
    image_path_5: '',
    image_category_5: null,
    image_cap_6: '',
    image_path_6: '',
    image_category_6: null,
    image_cap_7: '',
    image_path_7: '',
    image_category_7: null,
    image_cap_8: '',
    image_path_8: '',
    image_category_8: null,
    image_cap_9: '',
    image_path_9: '',
    image_category_9: null,
    image_cap_10: '',
    image_path_10: '',
    image_category_10: null,
    image_cap_11: '',
    image_path_11: '',
    image_category_11: null,
    image_cap_12: '',
    image_path_12: '',
    image_category_12: null,
    image_cap_13: '',
    image_path_13: '',
    image_category_13: null,
    image_cap_14: '',
    image_path_14: '',
    image_category_14: null,
    image_cap_15: '',
    image_path_15: '',
    image_category_15: null,
    image_cap_16: '',
    image_path_16: '',
    image_category_16: null,
    image_cap_17: '',
    image_path_17: '',
    image_category_17: null,
    image_cap_18: '',
    image_path_18: '',
    image_category_18: null,
    image_cap_19: '',
    image_path_19: '',
    image_category_19: null,
    image_cap_20: '',
    image_path_20: '',
    image_category_20: null,
    image_cap_21: '',
    image_path_21: '',
    image_category_21: null,
    image_cap_22: '',
    image_path_22: '',
    image_category_22: null,
    image_cap_23: '',
    image_path_23: '',
    image_category_23: null,
    image_cap_24: '',
    image_path_24: '',
    image_category_24: null,
    image_cap_25: '',
    image_path_25: '',
    image_category_25: null,
    image_cap_26: '',
    image_path_26: '',
    image_category_26: null,
    image_cap_27: '',
    image_path_27: '',
    image_category_27: null,
    image_cap_28: '',
    image_path_28: '',
    image_category_28: null,
    image_cap_29: '',
    image_path_29: '',
    image_category_29: null,
    image_cap_30: '',
    image_path_30: '',
    image_category_30: null,
    image_cap_31: '',
    image_path_31: '',
    image_category_31: null,
    image_cap_32: '',
    image_path_32: '',
    image_category_32: null,
    image_cap_33: '',
    image_path_33: '',
    image_category_33: null,
    image_cap_34: '',
    image_path_34: '',
    image_category_34: null,
    image_cap_35: '',
    image_path_35: '',
    image_category_35: null,
    image_cap_36: '',
    image_path_36: '',
    image_category_36: null,
    image_cap_37: '',
    image_path_37: '',
    image_category_37: null,
    image_cap_38: '',
    image_path_38: '',
    image_category_38: null,
    image_cap_39: '',
    image_path_39: '',
    image_category_39: null,
    image_cap_40: '',
    image_path_40: '',
    image_category_40: null,
    image_cap_41: '',
    image_path_41: '',
    image_category_41: null,
    image_cap_42: '',
    image_path_42: '',
    image_category_42: null,
    image_cap_43: '',
    image_path_43: '',
    image_category_43: null,
    image_cap_44: '',
    image_path_44: '',
    image_category_44: null,
    image_cap_45: '',
    image_path_45: '',
    image_category_45: null,
    image_cap_46: '',
    image_path_46: '',
    image_category_46: null,
    image_cap_47: '',
    image_path_47: '',
    image_category_47: null,
    image_cap_48: '',
    image_path_48: '',
    image_category_48: null,
    image_cap_49: '',
    image_path_49: '',
    image_category_49: null,
    image_cap_50: '',
    image_path_50: '',
    image_category_50: null,
  },
  rent_bc_tenant: {
    tenant_type: 1,
    tenant_name_last: '',
    tenant_name_first: '',
    tenant_name_last_kana: '',
    tenant_name_first_kana: '',
    tenant_corporate_name: '',
    tenant_corporate_name_kana: '',
    f_tenant_signature_stamp: 0,
    tenant_zip: '',
    tenant_zip1: null,
    tenant_zip2: null,
    tenant_pref_cd: null,
    tenant_shiku_cd: null,
    tenant_choson_cd: null,
    tenant_aza_cd: null,
    tenant_address_else: '',
    tenant_address_building: '',
    tenant_room_no: '',
    tenant_tel1: null,
    tenant_tel2: null,
    tenant_tel3: null,
    tenant_cellphone1: null,
    tenant_cellphone2: null,
    tenant_cellphone3: null,
    f_insurancespot_same: 0,
    insurancespot_zip1: null,
    insurancespot_zip2: null,
    insurancespot_pref_cd: null,
    insurancespot_shiku_cd: null,
    insurancespot_choson_cd: null,
    insurancespot_aza_cd: null,
    insurancespot_address_else: '',
    insurancespot_address_building: '',
    insurancespot_room_no: '',
    f_residents1_same: 0,
    residents1_last: '',
    residents1_first: '',
    residents1_last_kana: '',
    residents1_first_kana: '',
    residents1_birthday_y: null,
    residents1_birthday_m: null,
    residents1_birthday_d: null,
    residents2_last: '',
    residents2_first: '',
    residents2_last_kana: '',
    residents2_first_kana: '',
    residents2_birthday_y: null,
    residents2_birthday_m: null,
    residents2_birthday_d: null,
    residents3_last: '',
    residents3_first: '',
    residents3_last_kana: '',
    residents3_first_kana: '',
    residents3_birthday_y: null,
    residents3_birthday_m: null,
    residents3_birthday_d: null,
    f_else_residents: 0,
    f_else_residents_residents1_same: 0,
    f_else_residents_tenant_same: 0,
    else_residents_last: '',
    else_residents_first: '',
    else_residents_last_kana: '',
    else_residents_first_kana: '',
    else_residents_birthday_y: null,
    else_residents_birthday_m: null,
    else_residents_birthday_d: null,
    else_residents_grown_up: null,
    else_residents_children: null,
    else_residents_insured: null,
    insurance_fee_method: 1,
    insurance_convenience_no: '',
    insurance_date_receipt_y: null,
    insurance_date_receipt_m: null,
    insurance_date_receipt_d: null,
    insurance_commencement_y: null,
    insurance_commencement_m: null,
    insurance_commencement_d: null,
    insurance_term: 3,
    insurance_join_cource: null,
    f_insurance_input_finish_check: 0,
    insurance_bank_type: null,
    insurance_bank_code: '',
    insurance_bank_name: '',
    insurance_branch_code: '',
    insurance_branch_name: '',
    insurance_deposit_type: null,
    insurance_bankbook_no: '',
    insurance_account_name: '',
    insurance_bank_type_code_post: '',
    insurance_bank_contract_code_post: '',
    insurance_bankbook_symbol_post: '',
    insurance_bankbook_no_post: '',
    insurance_account_name_kana_post: '',
    f_else_insurance_contract_our: 0,
    f_else_insurance_contract_else: 0,
    else_insurance_contract_company: '',
    else_insurance_contract_insurance_type: '',
    else_insurance_contract_insurance_y: null,
    else_insurance_contract_insurance_m: null,
    else_insurance_contract_insurance_d: null,
    else_insurance_contract_insurance_sumprice: null,
    f_else_insurance_require_doc: 0,
    else_insurance_note: '',
  },
  rent_bc_campaign: {
    campaign_name: '',
    brokerage_campaign_name: '',
    campaign_reflection_term_from_y: null,
    campaign_reflection_term_from_m: null,
    campaign_reflection_term_from_d: null,
    campaign_reflection_term_to_y: null,
    campaign_reflection_term_to_m: null,
    campaign_reflection_term_to_d: null,
    campaign_usage_term: '',
    campaign_detail: '',
    campaign_term: '',
    f_campaign_deposit: 0,
    campaign_deposit_expense: null,
    unit_campaign_deposit_expense: null,
    f_campaign_keymoney: 0,
    campaign_keymoney_expense: null,
    unit_campaign_keymoney_expense: null,
    f_campaign_ad: 0,
    campaign_ad: null,
    unit_campaign_ad: null,
    f_campaign_freerent: 0,
    campaign_freerent: null,
    campaign_rent_start_y: null,
    campaign_rent_start_m: null,
    campaign_rent_start_d: null,
    campaign_freerent_detail: '',
  },
  rent_bc_energy_savings: {
    sel_renewable_energy_equipment: null,
    energy_consumption_performance: null,
    sel_insulation_performance: null,
    estimated_utility_costs: null,
    f_bels: 0,
    f_energy_saving_measures: 0,
    f_zeh: 0,
    f_zeh_level: 0,
    self_label_image_cap: '',
    self_label_image_path: '',
    external_label_image_cap: '',
    external_label_image_path: '',
  },
  rent_bc_itandibb: {
    account_key: '',
    company_group_name: '',
    sel_publication_range: null,
    preview_reservation_method: '',
    preview_cautions: '',
    preview_method: '',
    personal_guarantee_plan_id: '',
    corporate_guarantee_plan_id: '',
    sel_web_application_reception: null,
    sel_internet_fee: null,
    internet_free_company: '',
  },
}
